import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { VitalsService } from '../../vitals/services/vitals.service'
import { IOptionsResponse } from '../../../common/common.types'
import { setPainQualityOnsetUnitOptions } from '../store/options.actions'

export function* getPainQualityOnsetUnitOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([vitalsService, vitalsService.getUtilTimePeriods])
    const { entity } = response
    yield put(setPainQualityOnsetUnitOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getPainQualityOnsetUnitOptions() error: ${e}`))
  }
}

export function* getPainQualityOnsetUnitOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getPainQualityOnsetUnitOptions)
}
